import React from 'react';
import {FormFieldProps} from '../../../@types/components/Form';
import {IEmptyModel} from '../../../@interfaces/IEmptyModel';

export default function NestedFormFieldWidget<Model extends IEmptyModel>(props: FormFieldProps<Model>) {
    return <>NestedFormFieldWidget<pre>{JSON.stringify(props, null, 4)}</pre></>;
}
